// extracted by mini-css-extract-plugin
export default {"root":"IfHim","gif":"p591U","hideAnimationContainer":"VdI5X","shrinkToDot":"VsJl4"};